/* IMPORT */
import { OWNER } from './superroot.js';
import { lazyArrayPush } from '../lazy.js';
import Owner from './owner.js';
import { Stack } from '../methods/debugger.js';
/* MAIN */
class Context extends Owner {
    /* CONSTRUCTOR */
    constructor(context) {
        super();
        /* VARIABLES */
        this.parent = OWNER;
        this.context = { ...OWNER.context, ...context };
        lazyArrayPush(this.parent, 'contexts', this);
    }
    /* API */
    wrap(fn, owner, observer, stack) {
        return super.wrap(fn, this, undefined, stack);
    }
}
/* EXPORT */
export default Context;
